import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

const Header = props => (
  <header id="header" className="alt">
    <nav>
      <a
        className="menu-link"
        href="#"
        onClick={e => {
          e.preventDefault();
          props.onToggleMenu();
        }}>
        Menu
      </a>
    </nav>
  </header>
);

Header.propTypes = {
  onToggleMenu: PropTypes.func,
};

export default Header;
